/**
 * Determine the visibility of Swiper slides while printing.
 *
 * During printing, only the active slide is made visible while others are hidden.
 * After printing, all slides are reset to their original visibility state.
 */

export function handlePrintSlideVisibility() {
	const beforePrint = () => {
		const slides = document.querySelectorAll(
			'swiper-slide'
		) as NodeListOf<HTMLElement>
		slides.forEach((slide) => {
			slide.style.visibility =
				slide.classList.contains('precoa-slide-active') ||
				slide.classList.contains('swiper-slide-active')
					? 'visible'
					: 'hidden'
		})
	}

	const afterPrint = () => {
		const slides = document.querySelectorAll(
			'swiper-slide'
		) as NodeListOf<HTMLElement>
		slides.forEach((slide) => {
			slide.style.visibility = ''
		})
	}

	window.addEventListener('beforeprint', beforePrint)
	window.addEventListener('afterprint', afterPrint)
}
